import PartnerLogo from "../../assets/icons/partner-1.png";

export const partners = [
  "https://etimg.etb2bimg.com/photo/99813245.cms",
  "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Bharti_Airtel_Logo.svg/905px-Bharti_Airtel_Logo.svg.png",
  "https://cdn.pixabay.com/photo/2021/05/24/09/15/google-logo-6278331_1280.png",
  "https://pnggallery.com/wp-content/uploads/phonepe-logo-04.png",
];
